// extracted by mini-css-extract-plugin
module.exports = {"mobileView":"EcodrivePage_mobileView__2YLtD","imageBox":"EcodrivePage_imageBox__3RS0q","theoryPageTopContent":"EcodrivePage_theoryPageTopContent__2Fqyj"};